import { useEffect } from "react";

export function usePageMeta({ title, description, noindex = false, canonical = null }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const el = document.getElementById("meta-desc");
      if (el) el.setAttribute("content", description);
      const og = document.getElementById("og-desc");
      if (og) og.setAttribute("content", description);
    }
    let canon = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!canon) {
        canon = document.createElement("link");
        canon.setAttribute("rel", "canonical");
        document.head.appendChild(canon);
      }
      canon.setAttribute("href", canonical);
    } else if (canon) {
      canon.remove();
    }
    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, noindex, canonical]);
}
